import { IAppState } from 'src/app/store/state/app.state';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Store, select } from "@ngrx/store";
import * as fromSystem from "../selectors/system.selectors";
import * as systemActions from '../actions/system.actions';

@Injectable()
export class SystemFacade {
  isLoading$: Observable<boolean> = this.store.pipe(select(fromSystem.isLoading));

  constructor(private store: Store<IAppState>) { }

  getSystemStatus() {
    return this.store.pipe(select(fromSystem.getSystemStatus));
  }

  clearSystemStatus() {
    this.store.dispatch(new systemActions.UpdateStatus(null));
  }
}
